(function ($) {
  // -/+ stepper buttons on WooCommerce quantity fields (see
  // woocommerce/global/quantity-input.php). Delegated so it also works on
  // AJAX-injected content like the quick-view modal and updated cart tables.
  $(document).on('click', '.quantity .plus, .quantity .minus', function () {
    const $button = $(this);
    const $qty = $button.closest('.quantity').find('.qty');

    if (!$qty.length || $qty.prop('readonly')) return;

    const step = parseFloat($qty.attr('step')) || 1;
    const min = $qty.attr('min') !== '' ? parseFloat($qty.attr('min')) : 1;
    const max = $qty.attr('max') !== '' && $qty.attr('max') !== undefined ? parseFloat($qty.attr('max')) : Infinity;
    let value = parseFloat($qty.val()) || 0;

    value = $button.hasClass('plus') ? value + step : value - step;
    value = Math.min(Math.max(value, isNaN(min) ? 1 : min), isNaN(max) ? Infinity : max);

    $qty.val(value).trigger('change');
  });

  // Cart page: auto-update on quantity change — the hidden "Update cart"
  // button (app.scss) is clicked for the user, debounced so rapid -/+
  // clicks fire one AJAX refresh. Delegated: the form is replaced on
  // updated_wc_div, and WC core re-enables the button on the change event
  // before this timeout runs.
  let cartUpdateTimeout;
  $(document).on('change', '.woocommerce-cart-form input.qty', function () {
    clearTimeout(cartUpdateTimeout);
    cartUpdateTimeout = setTimeout(function () {
      $('.woocommerce-cart-form button[name="update_cart"]').trigger('click');
    }, 500);
  });
})(jQuery);
